module.exports = __webpack_public_path__ + "static/img/download-icon-white.52fd720f.svg";